const DEFAULT_FILL = "#0037ff";

/**
 * Virtual Teammates icon, kept in sync with Opal.
 *
 * `className` and `color` are not passed by us directly: Axiom's `Icon` clones this element
 * (see `isValidElement(name)` in `@optimizely/axiom`) whenever it is handed to an Axiom
 * component as `name`/`leftIcon`, and injects both. `color` therefore acts as the fill when no
 * explicit `fill` is given, which keeps the icon consistent with the Axiom icons beside it.
 */
export const VirtualTeammate = ({ className, color, fill }: { className?: string; color?: string; fill?: string }) => (
    <svg
        className={className}
        aria-hidden="true"
        data-testid="virtual-teammate-icon"
        width="20"
        height="16"
        viewBox="0 0 20 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M7.63965 9.5C7.37797 9.81138 7.14339 10.1459 6.93848 10.5H6.40625C3.96875 10.5 2 12.5 2 14.9375C2 14.9688 2.03125 15 2.0625 15H6.07227C6.12119 15.342 6.19453 15.6758 6.29102 16H2.0625C1.46875 16 1 15.5312 1 14.9375C1 11.9375 3.40625 9.5 6.40625 9.5H7.63965ZM11.5029 8.03223C11.7947 7.51378 12.5383 7.51378 12.8301 8.03223L13.8496 9.84375C13.9178 9.96496 14.0178 10.0653 14.1387 10.1338L15.9453 11.1562C16.4623 11.4488 16.4623 12.1947 15.9453 12.4873L14.1387 13.5088C14.0177 13.5773 13.9179 13.6785 13.8496 13.7998L12.8301 15.6113C12.5382 16.1295 11.7947 16.1296 11.5029 15.6113L10.4834 13.7998C10.4151 13.6785 10.3153 13.5773 10.1943 13.5088L8.3877 12.4873C7.87077 12.1947 7.87089 11.4489 8.3877 11.1562L10.1943 10.1338C10.3152 10.0654 10.4151 9.96497 10.4834 9.84375L11.5029 8.03223ZM14.7803 3.25879C14.9749 2.9138 15.4705 2.91365 15.665 3.25879L16.3447 4.4668C16.3903 4.54769 16.4574 4.61452 16.5381 4.66016L17.7412 5.3418C18.086 5.53686 18.086 6.03544 17.7412 6.23047L16.5381 6.91113C16.4574 6.95677 16.3903 7.02359 16.3447 7.10449L15.665 8.3125C15.4705 8.65773 14.9749 8.65758 14.7803 8.3125L14.0996 7.10449C14.0541 7.02371 13.9878 6.95673 13.9072 6.91113L12.7031 6.23047C12.3584 6.03542 12.3584 5.53684 12.7031 5.3418L13.9072 4.66016C13.9878 4.61455 14.0541 4.54758 14.0996 4.4668L14.7803 3.25879ZM8 0C10.1875 0 12 1.8125 12 4C12 6.21875 10.1875 8 8 8C5.78125 8 4 6.21875 4 4C4 1.8125 5.78125 0 8 0ZM8 1C6.34375 1 5 2.375 5 4C5 5.65625 6.34375 7 8 7C9.625 7 11 5.65625 11 4C11 2.375 9.625 1 8 1Z"
            fill={fill ?? color ?? DEFAULT_FILL}
        />
    </svg>
);
export default VirtualTeammate;

VirtualTeammate.displayName = "VirtualTeammate";
